import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
import { defineStore } from 'pinia'
import { useUserStore } from './UserStore'
import { computed } from 'vue'

export const useLinkStore = defineStore('linkStore', () => {
  const userStore = useUserStore()
  const { authGet, authPost } = useHallApi()
  const agentDomain = computed(() => userStore.agentDomain)
  const reqGetLinks = async () => {
    const r = await authGet<IGetLinksReply>(
      AgentApiPath.GetLinks,
      {},
      {
        showLoading: true,
        showErrorCodeTip: true
      }
    )

    return r.data
  }

  const reqAddLink = async (reqData: IAddLinkReq) => {
    const r = await authPost<any>(AgentApiPath.AddLink, reqData, {
      showLoading: true,
      showErrorCodeTip: true
    })

    return r
  }
  const reset = () => {}
  return { reset, reqGetLinks, reqAddLink, agentDomain }
})

export enum AgentLinksStatus {
  None = 0,
  /**
   * 链接状态初始化
   */
  Init = 1,
  /**
   * 链接生效 走完所有流程
   */
  Enabled = 2,
  /**
   * 链接流程中断 后续可重试
   */
  Pause = 3,
  /**
   * 连接流程终中断 需人工介入
   */
  Terminate = 4
}
export interface IGetLinksReply {
  links: ILinkInfo[]
}

export interface ILinkInfo {
  /**
   * 连接id
   */
  id: string
  /**
   * 代理id
   */
  agentId: string
  /**
   * 连接
   */
  link: string
  /**
   * 连接状态
   */
  status: AgentLinksStatus
  /**
   * 名称
   */
  tagName: string,
  /**
   * 注册人数
   */
  registerCount:number,
  /**
   * 创建时间戳
   */
  createAt: string
  /**
   * 更新时间戳
   */
  updatedAt: string
}

export interface IAddLinkReq {
  /**
   * 子域名
   */
  subDomain: string
  /**
   * 标签
   */
  tag: string
}
